<template>
  <div class="modal-drag-custom-drag" :class="$vuetify.breakpoint.mobile && 'mobile-popup'" :style="{ zIndex: indexModalIndex }">
		<modal
			name="custom_drag_modal"
			:style="{ zIndex: indexModalIndex }"
			hide-overlay
			draggable=".drag-header"
			:clickToClose="true"
			@before-close="closeModal"
			:focusTrap="true"
			:adaptive="true"
			height="auto"
			width="90%"
			:max-width="1200"
			:min-width="1000"
		>
      <v-card>
        <v-card-title class="pa-0 drag-header">
					<div class="d-flex flex-row align-center justify-space-between py-2 px-8 w-100">
						<div class="d-flex flex-row align-center">
							<v-icon class="mr-2">mdi-briefcase-outline</v-icon>
							<p class="mb-0 font-weight-bold text-primary title">Detalle Sub Contrato</p>
						</div>
						<div class="d-flex align-center" style="gap:15px;">
							<v-btn
								outlined
								dark
								small
								color="#959595"
								@click="toFullView"
							>
								<v-icon dark small class="mr-2">mdi-briefcase-outline</v-icon>
								<p class="mb-0 caption">Ir a Vista Completa</p>
							</v-btn>
							<v-tooltip>
								<template v-slot:activator="{ on, attrs }">
									<div v-bind="attrs" v-on="on">
										<v-btn
											icon
											dark
											small
											color="#959595"
											@click="toNewWindow"
										>
											<v-icon>mdi-open-in-new</v-icon>
										</v-btn>
									</div>
								</template>
								<span>Abrir en nueva ventana</span>
							</v-tooltip>
							<v-btn fab dark small color="#FF1209" @click="closeModal">
								<v-icon dark>mdi-close</v-icon>
							</v-btn>
						</div>
					</div>
				</v-card-title>
        <v-card-text class="pa-0">
					<ContractDetailComponent :contractId="$store.state.contracts.contractComponentModalId" contractType="subcontract"/>
        </v-card-text>
      </v-card>
    </modal>
  </div>
</template>

<script>
import ContractDetailComponent from '@/components/Views/Contracts/ContractDetailComponent'

export default {
  name: 'SubContractComponentModal',
  components: { ContractDetailComponent },
  data: () => ({
		indexModal: + new Date(),
  }),
  computed: {
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
  mounted(){
		this.$modal.show('custom_drag_modal')
			this.$store.commit('general/addOpenModalOrders', this.indexModal)
  },
  methods: {
    closeModal(){
      this.$store.commit('contracts/setSubcontractComponentModalId', null)
    },
		toFullView(){
			this.$router.push({ name: 'SubcontractDetail', query: { id: this.$store.state.contracts.subcontractComponentModalId } })
			this.closeModal()
		},
		toNewWindow(){
			window.open(
				`/built-in-content?type=subcontract&id=${this.$store.state.contracts.subcontractComponentModalId}`,
				'',
				'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
			);
		}
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>